import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		main: {
			landing: {
				ids: ['loader-main'],
				experiment: () =>
					import('@/modules/Landing/instances/experiments/web_fasting_fem_social_proof_on_first_and_paywall'),
			},
		},
		female: {
			// ?safe&mock-data&utm_source=FB&country=US&area=female&exp=web_fasting_fem_social_proof_on_first_and_paywall~1
			funnel: {
				id: 'ob-female-social-proof',
				locale: ['en'],
			},
			landing: {
				ids: ['loader-f'],
				experiment: () =>
					import('@/modules/Landing/instances/experiments/web_fasting_fem_social_proof_on_first_and_paywall'),
			},
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=female&exp=web_fasting_fem_social_proof_on_first_and_paywall~1
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_fasting_fem_social_proof_on_first_and_paywall'
					),
			},
		},
	},
]

export default config
